import { Controller } from "@hotwired/stimulus"

// One search area, three registers: tap a tab and only the panel below
// changes. The chosen tab is kept in the URL hash (#ljekarne) so "dodaj"
// and "spremi" can return to the right one. Without JavaScript all panels
// simply show, one under the other.
export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    this.fromHash()
    this.onHash = () => this.fromHash()
    window.addEventListener("hashchange", this.onHash)
  }

  disconnect() { window.removeEventListener("hashchange", this.onHash) }

  fromHash() {
    const wanted = location.hash.replace("#", "")
    const known = this.panelTargets.some((p) => p.dataset.tabName === wanted)
    this.show(known ? wanted : this.tabTargets[0].dataset.tabName, false)
  }

  select(event) {
    event.preventDefault()
    this.show(event.currentTarget.dataset.tabName, true)
  }

  show(name, updateHash) {
    this.tabTargets.forEach((t) => {
      const on = t.dataset.tabName === name
      t.classList.toggle("is-active", on)
      t.setAttribute("aria-selected", on)
    })
    this.panelTargets.forEach((p) => { p.hidden = p.dataset.tabName !== name })
    if (updateHash) history.replaceState(null, "", `#${name}`)
    const input = this.panelTargets.find((p) => !p.hidden)?.querySelector("input[name=q]")
    if (input && updateHash) input.focus()
  }
}
